module.exports = __webpack_public_path__ + "static/map02-41f43ae9d9e50d4ed6498b426e25244b.png";